import BluetoothIcon from '@mui/icons-material/Bluetooth';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import DialpadIcon from '@mui/icons-material/Dialpad';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import HelpOutlineIcon from '@mui/icons-material/HelpOutlined';
import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';
import PhoneLockedIcon from '@mui/icons-material/PhoneLocked';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import SvgIcon from '@mui/material/SvgIcon';
import Tooltip from '@mui/material/Tooltip';
import { uniqBy } from 'lodash';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as ApiAccessIcon } from '../../../assets/access-api.svg';
import { ACCESS_LOG_CREDENTIAL_TYPE, ACCESS_LOG_FAILED_RESULTS, ACCESS_LOG_RESULT } from '../../../config/consts';
import { getAccessTypeMessage } from '../helpers/getAccessTypeMessage';
import messages from '../messages';
import { AccessLogPropType } from '../type';

const accessTypeTooltip = (credential, accessLog) => {
  const message = getAccessTypeMessage(credential, accessLog, 'tooltip');
  return <FormattedMessage {...message} />;
};

const AccessLogAccessType = ({ accessLog }) => (
  <>
    {accessLog.result === ACCESS_LOG_RESULT.UNAUTHORIZED && (
      <Tooltip
        placement="right"
        title={<FormattedMessage {...messages.accessLogResultIconAccessTypeTooltipUnauthorizedAccess} />}
      >
        <LoginIcon data-testid="LoginIcon" sx={{ color: 'error.dark' }} />
      </Tooltip>
    )}

    {uniqBy(accessLog.credentials, 'type')?.map((credential) => {
      const iconProps = {
        sx: {
          color: ACCESS_LOG_FAILED_RESULTS.includes(accessLog?.result) ? 'error.dark' : 'primary.main',
        },
      };

      let icon = null;
      switch (credential?.type) {
        case ACCESS_LOG_CREDENTIAL_TYPE.MOBILE_KEY:
          icon = <BluetoothIcon data-testid="BluetoothIcon" {...iconProps} />;
          break;
        case ACCESS_LOG_CREDENTIAL_TYPE.CARD:
          icon = <CreditCardIcon data-testid="CreditCardIcon" {...iconProps} />;
          break;
        case ACCESS_LOG_CREDENTIAL_TYPE.FINGER_PRINT:
          icon = <FingerprintIcon data-testid="FingerprintIcon" {...iconProps} />;
          break;
        case ACCESS_LOG_CREDENTIAL_TYPE.CODE:
          icon = <DialpadIcon data-testid="DialpadIcon" {...iconProps} />;
          break;
        case ACCESS_LOG_CREDENTIAL_TYPE.QR_CODE:
          icon = <QrCode2Icon data-testid="QrCode2Icon" {...iconProps} />;
          break;
        case ACCESS_LOG_CREDENTIAL_TYPE.MAPI:
        case ACCESS_LOG_CREDENTIAL_TYPE.PAPI:
          icon = (
            <SvgIcon {...iconProps} data-testid="ApiIcon">
              <ApiAccessIcon />
            </SvgIcon>
          );
          break;
        case ACCESS_LOG_CREDENTIAL_TYPE.REMOTE:
          if (accessLog?.detail?.log === 'Access originator: api') {
            icon = (
              <SvgIcon {...iconProps} data-testid="ApiIcon">
                <ApiAccessIcon />
              </SvgIcon>
            );
          } else {
            icon = <PhoneLockedIcon data-testid="PhoneLockedIcon" {...iconProps} />;
          }
          break;
        case ACCESS_LOG_CREDENTIAL_TYPE.REX:
          icon = <LogoutIcon data-testid="LogoutIcon" {...iconProps} />;
          break;
        case ACCESS_LOG_CREDENTIAL_TYPE.LICENSE_PLATE:
          icon = <DirectionsCarIcon data-testid="DirectionsCarIcon" {...iconProps} />;
          break;
        default:
          icon = <HelpOutlineIcon data-testid="HelpOutlineIcon" {...iconProps} />;
          break;
      }

      return (
        <Tooltip key={credential?.type} placement="right" title={accessTypeTooltip(credential, accessLog)}>
          {icon}
        </Tooltip>
      );
    })}
  </>
);

AccessLogAccessType.propTypes = {
  accessLog: AccessLogPropType.isRequired,
};

export default AccessLogAccessType;
